var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('li',{staticClass:"bet-size-option",class:{ 'active': _vm.active },on:{"click":_vm.handleBetSizeOptionClick}},[_vm._v(" "+_vm._s(_vm.spins)+" x "+_vm._s(_vm._f("currencyFormat")(_vm.ba))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }